import { RedirectToSignIn, SignedIn, SignedOut } from '@clerk/clerk-react';
import { OnboardingFlow } from '@/components/onboarding/flow/OnboardingFlow';

export default function OnboardingPage() {
  return (
    <>
      <SignedOut>
        <RedirectToSignIn redirectUrl="/onboarding" />
      </SignedOut>
      <SignedIn>
        <OnboardingFlow />
      </SignedIn>
    </>
  );
}
